import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { lazy } from 'react';
import { RouteConfig } from 'vue-router';

const ticketManagement: RouteConfig = {
  path: '/workTicketManagement',
  name: 'workticketmanagement',
  meta: {
    title: 'Work Ticket Management',
    icon: 'Work Ticket Management',
  },
  redirect: '/workTicketManagement/workTicketManagement',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: 'workTicketManagement',
      name: 'workticketmanagement.workticketmanagement',
      meta: {
        title: 'Work Ticket Management',
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.workticketmanagement',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/work-ticket-management/index'
              )
          ),
      },
    },
    {
      path: 'workTicketManagement/detail/:id',
      name: 'workticketmanagement.workticketmanagement.detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'workticketmanagement',
            title: 'Work Ticket Management',
          },
          {
            routeName: 'workticketmanagement.workticketmanagement',
            title: 'Work Ticket Management',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.workticketmanagement.detail',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/work-ticket-management/detail-page/index'
              )
          ),
      },
    },
    {
      path: 'workTicketManagement/handle/:id',
      name: 'workticketmanagement.workticketmanagement.handle',
      meta: {
        title: 'Handle',
        menuHide: true,
        navList: [
          {
            routeName: 'workticketmanagement',
            title: 'Work Ticket Management',
          },
          {
            routeName: 'workticketmanagement.workticketmanagement',
            title: 'Work Ticket Management',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.workticketmanagement.handle',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/work-ticket-management/detail-page/index'
              )
          ),
      },
    },
    {
      path: 'ticketTypeSetting',
      name: 'workticketmanagement.tickettypesetting',
      meta: {
        title: 'Ticket Type Setting',
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.tickettypesetting',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/ticket-type-setting/index'
              )
          ),
      },
    },
    {
      path: 'ticketTypeSetting/create',
      name: 'workticketmanagement.tickettypesetting.create',
      meta: {
        title: 'Create',
        menuHide: true,
        navList: [
          {
            routeName: 'workticketmanagement',
            title: 'Work Ticket Management',
          },
          {
            routeName: 'workticketmanagement.tickettypesetting',
            title: 'Ticket Type Setting',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.tickettypesetting.create',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/ticket-type-setting/detail-page/index'
              )
          ),
      },
    },
    {
      path: 'ticketTypeSetting/edit/:id',
      name: 'workticketmanagement.tickettypesetting.edit',
      meta: {
        title: 'Edit',
        menuHide: true,
        navList: [
          {
            routeName: 'workticketmanagement',
            title: 'Work Ticket Management',
          },
          {
            routeName: 'workticketmanagement.tickettypesetting',
            title: 'Ticket Type Setting',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.tickettypesetting.edit',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/ticket-type-setting/detail-page/index'
              )
          ),
      },
    },
    {
      path: 'supervisorConfig',
      name: 'workticketmanagement.supervisorconfig',
      meta: {
        title: 'Supervisor Config',
      },
      component: reactContainerFactory({
        name: 'workticketmanagement.supervisorconfig',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/work-ticket-management/supervisor-config/index'
              )
          ),
      },
    },
  ],
};
export default ticketManagement;
